/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_PaintingInputs */

const en_val_painting = /** @type {(inputs: Val_PaintingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Painting`)
};

const es_val_painting = /** @type {(inputs: Val_PaintingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pintura`)
};

const fr_val_painting = /** @type {(inputs: Val_PaintingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peinture`)
};

const de_val_painting = /** @type {(inputs: Val_PaintingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemälde`)
};

const ja_val_painting = /** @type {(inputs: Val_PaintingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`絵画`)
};

const zh_val_painting = /** @type {(inputs: Val_PaintingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画作`)
};

const ar_val_painting = /** @type {(inputs: Val_PaintingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لوحة فنية`)
};

const id_val_painting = /** @type {(inputs: Val_PaintingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lukisan`)
};

const it_val_painting = /** @type {(inputs: Val_PaintingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pittura / Dipinto`)
};

const ru_val_painting = /** @type {(inputs: Val_PaintingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Картина / Живопись`)
};

const pt_val_painting = /** @type {(inputs: Val_PaintingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pintura`)
};

const ko_val_painting = /** @type {(inputs: Val_PaintingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`회화`)
};

/**
* | output |
* | --- |
* | "Painting" |
*
* @param {Val_PaintingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_painting = /** @type {((inputs?: Val_PaintingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_PaintingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_painting(inputs)
	if (locale === "es") return es_val_painting(inputs)
	if (locale === "fr") return fr_val_painting(inputs)
	if (locale === "de") return de_val_painting(inputs)
	if (locale === "ja") return ja_val_painting(inputs)
	if (locale === "zh") return zh_val_painting(inputs)
	if (locale === "ar") return ar_val_painting(inputs)
	if (locale === "id") return id_val_painting(inputs)
	if (locale === "it") return it_val_painting(inputs)
	if (locale === "ru") return ru_val_painting(inputs)
	if (locale === "pt") return pt_val_painting(inputs)
	return ko_val_painting(inputs)
});